//filters
export const FILTERS = 'filters';

export const FILTER_ADDED = 'added';
export const FILTER_PERIOD = 'period';
export const FILTER_ACTIONS_TYPE = 'actionsType';
export const FILTER_TYPES = 'adjustmentTypes';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_CLUSTERS = 'clusterIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_STATUSES = 'statuses';
export const FILTER_CREATED_BY = 'createdBy';
export const FILTER_REASONS = 'reasons';
export const GA_FILTER_ADDED = 'addedRange';
export const GA_FILTER_PERIOD = 'periodRange';

// searchQuery
export const SEARCH_QUERY = 'searchQuery';
export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_ID = 'id';
export const COLUMN_TYPE = 'type';
export const COLUMN_PERIOD = 'period';
export const COLUMN_AFFILIATE = 'affiliate';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_APPROVERS = 'approvers';
export const COLUMN_CAMPAIGNS = 'campaigns';
export const COLUMN_NETWORK = 'network';
export const COLUMN_PLATFORM = 'platform';
export const COLUMN_CLUSTER = 'cluster';
export const COLUMN_AMOUNT = 'amount';
export const COLUMN_ORIGINAL_AMOUNT = 'originalAmount';
export const COLUMN_CURRENCY = 'currency';
export const COLUMN_STATUS = 'status';

export const COLUMN_REASON = 'adjustmentReason';

export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_UPDATED_DATE = 'updatedDate';

export const TEMPLATE_NEW_SPEND_ADJUSTMENT = 'newSpendAdjustment';
export const TEMPLATE_UPLOAD_BY_CAMPAIGNS = 'uploadByCampaigns';
